import {gql} from "@apollo/client";

export const GET_JOB_DEFINITIONS = gql`
	query GetJobDefinitions(
		$before: String
		$after: String
		$first: Int
		$last: Int
		$where: JobDefinitionFilterInput
		$order: [JobDefinitionSortInput!]
		) {
		jobDefinitions(
			before: $before
			after: $after
			first: $first
			last: $last
			where: $where
			order: $order
		) {
			nodes {
				id
				description
				name
				inputType
				jobSteps {
					id
				}
				tags {
					id
					key
					value
				}
			}
		}
	}
`;
